export default "__VITE_ASSET__76d9aee8__"